module.exports = new __parcel__URL__("pacman-energizer.0855a9bf.mp3").toString();